module.exports = __webpack_public_path__ + "img/file_icon.b2969866.svg";